import styles from "./CoachMatchingPublicScreen.module.scss";

import { useEffect, useRef } from "react";

import { BookingWidget } from "@/modules/coaching/booking/components/BookingWidget";
import {
  BookingContextProvider,
  BookingKinds,
} from "@/modules/coaching/booking/context/BookingContext";
import { PageContainer } from "@/modules/shared/components/PageContainer";
import { ROUTES } from "@/modules/shared/consts/routes";
import { captureEvent } from "@/modules/shared/utils/posthog";
import { COACH_MATCHING_PAGE_EVENTS } from "@/modules/tracking/consts/Events";
import { ShortUrlSource } from "@/modules/tracking/consts/ShortUrl";

interface CoachMatchingPublicScreenProps {
  memberName?: string;
  memberEmail?: string;
  source?: ShortUrlSource;
}

export function CoachMatchingPublicScreen({
  memberName,
  memberEmail,
  source = "unknown",
}: CoachMatchingPublicScreenProps) {
  const hasTrackedView = useRef(false);

  useEffect(() => {
    if (hasTrackedView.current) return;
    hasTrackedView.current = true;

    captureEvent(COACH_MATCHING_PAGE_EVENTS.PAGE_VIEWED, {
      has_prefilled_name: Boolean(memberName),
      has_prefilled_email: Boolean(memberEmail),
      source,
    });
  }, [memberName, memberEmail, source]);

  return (
    <PageContainer variant="centered">
      <div className={styles.widgetWrapper}>
        <BookingContextProvider
          initialData={{
            bookingKind: BookingKinds.COACH_MATCHING_SERVICE,
            memberName,
            memberEmail,
            isPrefillEditable: true,
          }}
        >
          <BookingWidget compact supportRoute={ROUTES.support.index} />
        </BookingContextProvider>
      </div>
    </PageContainer>
  );
}
